// extracted by mini-css-extract-plugin
export default {"wrapper":"Emails_wrapper__FNMSU","card":"Emails_card__FOfhv","title":"Emails_title__+nDlY","form":"Emails_form__QLqZF","button":"Emails_button__mBLXR"};